import { Controller } from "@hotwired/stimulus"

// Contrôleur pour les modals
// Usage: data-controller="modal" sur le conteneur du modal
export default class extends Controller {
  static targets = ["container", "backdrop", "content"]

  connect() {
    // Fermer avec Escape
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  open(event) {
    event?.preventDefault()
    this.containerTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    event?.preventDefault()
    this.containerTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")

    // Vider le contenu du modal si c'est un Turbo Frame
    if (this.hasContentTarget) {
      const frame = this.contentTarget.querySelector("turbo-frame")
      if (frame) {
        frame.innerHTML = ""
      }
    }
  }

  // Fermer si on clique sur le backdrop
  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }
}
